module.exports = __webpack_public_path__ + "img/logo-text.c01347cb.svg";